module.exports = __webpack_public_path__ + "media/packs/images/flags/LK-636d2798e9207b2c0de4be02adcb6b27.png";